var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter_657_5935_dd",
    x: -0.861328,
    y: -0.793945,
    width: 48,
    height: 42.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.33333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect_dropShadow_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect_dropShadow_1",
    result: "shape"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter_657_5935_dd)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.38 21.45C4.71 21.45 5.03 21.58 5.27 21.82C5.5 22.05 5.63 22.37 5.63 22.7L5.63 28.95C5.63 29.61 5.9 30.25 6.37 30.72C6.83 31.19 7.47 31.45 8.13 31.45L38.13 31.45C38.8 31.45 39.43 31.19 39.9 30.72C40.37 30.25 40.63 29.61 40.63 28.95L40.63 22.7C40.63 22.37 40.77 22.05 41 21.82C41.23 21.58 41.55 21.45 41.88 21.45C42.21 21.45 42.53 21.58 42.77 21.82C43 22.05 43.13 22.37 43.13 22.7L43.13 28.95C43.13 30.28 42.61 31.55 41.67 32.49C40.73 33.42 39.46 33.95 38.13 33.95L8.13 33.95C6.81 33.95 5.54 33.42 4.6 32.49C3.66 31.55 3.13 30.28 3.13 28.95L3.13 22.7C3.13 22.37 3.27 22.05 3.5 21.82C3.73 21.58 4.05 21.45 4.38 21.45Z",
    fill: "#DADADA",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.25 26.34C22.36 26.45 22.5 26.54 22.65 26.61C22.81 26.67 22.97 26.7 23.13 26.7C23.3 26.7 23.46 26.67 23.61 26.61C23.76 26.54 23.9 26.45 24.02 26.34L31.52 18.84C31.75 18.6 31.88 18.28 31.88 17.95C31.88 17.62 31.75 17.3 31.52 17.07C31.28 16.83 30.97 16.7 30.63 16.7C30.3 16.7 29.98 16.83 29.75 17.07L24.38 22.43L24.38 0.45C24.38 0.12 24.25 -0.2 24.02 -0.43C23.78 -0.67 23.46 -0.8 23.13 -0.8C22.8 -0.8 22.48 -0.67 22.25 -0.43C22.01 -0.2 21.88 0.12 21.88 0.45L21.88 22.43L16.52 17.07C16.28 16.83 15.97 16.7 15.63 16.7C15.3 16.7 14.98 16.83 14.75 17.07C14.51 17.3 14.38 17.62 14.38 17.95C14.38 18.28 14.51 18.6 14.75 18.84L22.25 26.34Z",
    fill: "#DADADA",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.49df400d29a8fe4644114127ecf1e127.svg";
export { ForwardRef as ReactComponent };